"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16VehicleCar = function Svg16VehicleCar(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12c0-.195-.028-.388-.084-.575l-1.18-3.93A3.5 3.5 0 0 0 15.384 5H8.616a3.5 3.5 0 0 0-3.352 2.494l-1.18 3.931A2 2 0 0 0 4 12v6.2c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C4.38 19 4.52 19 4.8 19h.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527V17h11v1.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C20 18.62 20 18.48 20 18.2V12zm-2.45-1.5l-.73-2.431A1.5 1.5 0 0 0 15.385 7H8.616a1.5 1.5 0 0 0-1.437 1.069L6.45 10.5h11.1zm.45 3.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM7.25 15a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16VehicleCar.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16VehicleCar;
exports.default = _default;